import { buscarDadosUsuarioLogado } from "@/services/UsuarioService.js";
import { buscarParametros } from "@/services/ParametrosService.js";

export const carregarDadosFixosUsuarioNaoLogado = (store) => {
	store.commit("dadosFixos/setCarregando", true);
	const requestList = [
		buscarParametros(),
	];
	Promise.all(requestList)
		.then(([
			{ data: parametrosData },
		]) => {
			store.commit("dadosFixos/setParametros", parametrosData);
			store.commit("dadosFixos/setCarregouDadosFixos", true);
		})
		.catch((e) => {
			console.error("Erro ao buscar dados fixos!");
			console.error(e);
			console.error(e.response);
			return Promise.reject();
		})
		.finally(() => {
			store.commit("dadosFixos/setCarregando", false);
			return Promise.resolve();
		});
};

export const carregarDadosFixosUsuarioNaoLogadoAsync = (store) => {
	return new Promise((resolve, reject) => {
		store.commit("dadosFixos/setCarregando", true);
		const requestList = [
			buscarParametros(),
		];
		Promise.all(requestList)
			.then(([
				{ data: parametrosData },
			]) => {
				store.commit("dadosFixos/setParametros", parametrosData);
				store.commit("dadosFixos/setCarregouDadosFixos", true);
			})
			.catch((e) => {
				console.error("Erro ao buscar dados fixos!");
				console.error(e);
				console.error(e.response);
				reject();
			})
			.finally(() => {
				store.commit("dadosFixos/setCarregando", false);
				resolve();
			});
	});
};

export const carregarDadosFixosUsuarioLogado = (store) => {
	store.commit("usuario/setCarregandoUsuario", true);

	buscarDadosUsuarioLogado()
		.then(({ data }) => {
			store.commit("usuario/setUsuarioLogado", data);
			store.commit("usuario/setCarregouUsuarioComSucesso", true);
		})
		.catch((e) => {
			console.error(e);
		})
		.finally(() => {
			store.commit("usuario/setCarregandoUsuario", false);
			return Promise.resolve();
		});
};

export const carregarDadosFixosUsuarioLogadoAsync = (store) => {
	return new Promise((resolve, reject) => {
		store.commit("usuario/setCarregandoUsuario", true);
		const requestList = [
			buscarDadosUsuarioLogado(),
		];
		Promise.all(requestList)
			.then(([
				{ data: dadosUsuarioLogado },
			]) => {
				store.commit("usuario/setUsuarioLogado", dadosUsuarioLogado);
				store.commit("usuario/setCarregouUsuarioComSucesso", true);
			})
			.catch(() => {
				reject();
			})
			.finally(() => {
				store.commit("usuario/setCarregandoUsuario", false);
				resolve();
			});
	});
};
